import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { css } from "styled-components";
import { colors } from "healthex-common/colors";
const gradientIds = {
    accents_gradient: { start: colors.accents_gradient_start, stop: colors.accents_sunset, rotate: 135 },
};
export const SVGGradientProvider = (props) => {
    return (_jsxs(_Fragment, { children: [props.children, Object.entries(gradientIds).map(([gradientId, gradient]) => (_jsx("svg", { width: 0, height: 0, style: { display: "block" }, children: _jsxs("linearGradient", { id: gradientId, x1: 1, y1: 0, x2: 1, y2: -1, gradientTransform: `rotate(${gradient.rotate})`, children: [_jsx("stop", { offset: 0, stopColor: gradient.start }), _jsx("stop", { offset: 1, stopColor: gradient.stop })] }) }, gradientId)))] }));
};
export function svgGradientStyle(gradientId) {
    return css `
        fill: url("#${gradientId}");
    `;
}
